import * as React from 'react';
import style from '../../../LibraryView.scss';
import propStyle from './Property.scss';
import { sectionPrefix } from '../../../../NavigationMenu/utils';
import MemberDocs, { MemberTypes } from '../../../../TypeDetails/MemberDocs';
import { TypeRectangle } from '../../../../PageElements/TypeRectangle';
import { MixedInFrom } from '../../../AdditionalInfo/MixedInFrom';
import { RelatedContentEndOfArticle } from '../../../../TypeDetails/RelatedContentEndOfArticle';
import { FeedbackContainer } from '../../../../Feedback';
import { CodeExamples } from '../../../../CodeExamples';
import { IntersectionSubscriber } from '../../../../SectionIntersectionDetection/IntersectionSubscriber';

export const Property = ({ property, prefix, node }) => {
  const JSLayoutType = node?.data?.layoutType === 'JS';
  const withHashPrefix = sectionPrefix(prefix, property.urlFormat);
  const {
    name,
    docs,
    type,
    typeDisplayName,
    mixedInFrom,
    defaultValue: _defaultValue,
  } = property;

  const links = docs && docs.links;

  const getPossibleOperation = () => {
    const { get: canRead, set: canWrite } = property;
    if (canRead && canWrite) {
      return 'Read & Write';
    }
    if (canWrite) {
      return 'Write Only';
    }
    if (canRead) {
      return 'Read Only';
    }
    return '';
  };

  const getDefaultValue = () => {
    return _defaultValue ? `default value is ${_defaultValue}` : '';
  };

  const getLabelInTypeDisplay = () => {
    const possibleOperation = getPossibleOperation();
    const defaultValue = getDefaultValue();
    if (possibleOperation && defaultValue) {
      return `${possibleOperation}, ${defaultValue}`;
    }
    if (possibleOperation) {
      return possibleOperation;
    }
    if (defaultValue) {
      return defaultValue;
    }
    return '';
  };

  const shouldPresentRelatedContent = links && links.length > 0;

  return (
    <section className={style.sectionWrapper}>
      <IntersectionSubscriber
        tagName="div"
        className={style.intersectionSubscriber}
        id={withHashPrefix}
      />
      <div className={propStyle.propertyWrapper}>
        <MemberDocs
          memberType={MemberTypes.PROPERTY}
          memberObject={property}
          node={node}
          prefix={prefix}
        />
        <TypeRectangle
          label={getLabelInTypeDisplay()}
          title="Type:"
          type={type}
          className={style.propertyType}
          displayName={typeDisplayName}
          pageName={name}
          prefix={prefix}
        />
        {mixedInFrom && (
          <div data-hook="inherited-from-container">
            <MixedInFrom
              items={[`${mixedInFrom.memberOf}.${mixedInFrom.name}`]}
            />
          </div>
        )}
        {shouldPresentRelatedContent && (
          <RelatedContentEndOfArticle links={links} prefix={prefix} />
        )}
        <FeedbackContainer memberId={withHashPrefix} />
      </div>
      <CodeExamples
        data={property}
        prefix={prefix}
        JSLayoutType={JSLayoutType}
      />
    </section>
  );
};
